<template>
  <div>
    <el-table :data="billList" v-if="billType == 'huazhuan'">
        <el-table-column label="时间">
          <template slot-scope="scope">
            <span>{{scope.row.businessTime | moment}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="businessType" label="账号"></el-table-column>
        <el-table-column prop="businessType" label="币种"></el-table-column>
        <el-table-column prop="businessType" label="转出账户"></el-table-column>
        <el-table-column prop="businessType" label="转入账户"></el-table-column>
        <el-table-column prop="businessType" label="数量"></el-table-column>
      </el-table>
      
    <el-table :data="billList|filterList" v-else>
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{scope.row.businessTime | moment}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="账号ID" width="250"></el-table-column>
      <el-table-column prop="coinType" label="币种" width="250"></el-table-column>

      <el-table-column prop="businessType" label="类型"></el-table-column>

    <el-table-column v-if="billType=='30'" prop="walletType" key="toone" label="转入账户"></el-table-column>
    <el-table-column v-if="billType=='30'" key="fromone" label="转出账户">
      <template slot-scope="scope">
        <span style="color:#409EFF;cursor: pointer;" @click="getlook(scope.row,31,scope.$index)">{{scope.row.lookwallet}}</span>
      </template>
    </el-table-column>

    <el-table-column v-if="billType=='31'" key="totwo" label="转入账户">
      <template slot-scope="scope">
        <span style="color:#409EFF;cursor: pointer;" @click="getlook(scope.row,30,scope.$index)">{{scope.row.lookwallet}}</span>
      </template>
    </el-table-column>
    <el-table-column v-if="billType=='31'" key="fromtwo" prop="walletType" label="转出账户"></el-table-column>


      <el-table-column label="可用变动">
        <template slot-scope="scope">
          <span>{{scope.row.availableAmountChange}} {{scope.row.coinType}}</span>
        </template>
      </el-table-column>
      <el-table-column label="可用">
          <template slot-scope="scope">
              {{scope.row.availableAfterChange}} {{scope.row.coinType}}
          </template>
      </el-table-column>
      <el-table-column label="冻结变动">
          <template slot-scope="scope">
              {{scope.row.frozenAmountChange}} {{scope.row.coinType}}
          </template>
      </el-table-column>
      <el-table-column label="冻结">
          <template slot-scope="scope">
              {{scope.row.frozenAfterChange}} {{scope.row.coinType}}
          </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark"/>
    </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handleCurrentChange"
        >
      </pagination>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import '../../store';
import api from '../../api';
export default {
  name: 'BillList',
  computed: {
    ...mapState('userBill', ['totalCount', 'pagination']),
    ...mapGetters('userBill', ['billList'])
  },
  data(){
    return{
      walletTypes: [
          {name: "我的钱包", code: "WALLET"},
          //{name: '交易账户', code: 'SPOT'},
          {name: '杠杆账户', code: 'MARGIN'},
          {name: "法币账户", code: "OTC"},
          {name: '合约账户', code: 'CONTRACT'},
          //{name: '理财账户', code: 'FINANCIAL'},
          {name: '超级合约账户账户', code: 'GENERAL'},
      ],    
      lookdetail:{}    
    }
  },
  props: {
    billType: {
      typeof: String,
      default: ''
    }
  },
  components: {
    Pagination
  },
  
  methods: {
      // ...mapActions('userBill', ['getLook']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    getlook(data,state,index){
      let obj = {billType:state,businessKey:data.businessKey,createTime:data.businessTime}
      api.getLook(obj).then(({ data }) => {
        if(data != null){
          data.walletType=  data.walletType == 'WALLET'?
        '我的钱包':data.walletType == 'MARGIN'?
        '杠杆账户':data.walletType == 'OTC'?
        '法币账户':data.walletType == 'CONTRACT'?'合约账户':'超级合约账户账户'
        }
        if(data){
          this.billList[index].lookwallet = data.walletType
        }else{
            this.$message.warning('没有账户');
        }
      });
    }
  },
  filters: {
    filterList:(value)=>{
      
    return value.filter(item=>
        item.walletType=  item.walletType == 'WALLET'?
      '我的钱包':item.walletType == 'MARGIN'?
      '杠杆账户':item.walletType == 'OTC'?
      '法币账户':item.walletType == 'CONTRACT'?'合约账户':'超级合约账户账户')
     
    }
  },
};
</script>

<style lang="less" scoped>
</style>
